import link from './service';
export default {
    link
};